import { Product } from "@/app/page";
import { Language, useTranslations } from "@/lib";
import { Trash } from "lucide-react";
export function ProductItem({
  product,
  onRemove,
  lang,
}: {
  product: Product;
  onRemove?: () => void;
  lang: Language;
}) {
  const { t } = useTranslations(lang);
  return (
    <div key={product.id} className="tw:flex tw:gap-x-2 tw:items-start">
      <div className="tw:h-20 tw:w-20 tw:md:h-28 tw:md:w-28">
        <img
          src={product.imageUrl}
          alt={product.name}
          className="tw:h-full tw:w-full tw:object-cover"
        />
      </div>

      <div className="tw:flex tw:flex-col tw:justify-center tw:w-1/2 tw:md:pr-5 tw:gap-1">
        <span className="tw:font-semibold">{product.title}</span>
        <span className="tw:md:text-base tw:text-sm tw:font-medium fht-drawer-price">
          {product.size || product.variant}
        </span>
      </div>

      <div className="tw:col-span-1 tw:flex tw:flex-col tw:items-end tw:justify-center tw:gap-1 tw:ml-auto">
        <span
          className="tw:text-xs tw:md:text-sm tw:font-bold tw:text-right"
          dangerouslySetInnerHTML={{ __html: product.price }}
        />

        {!product.size ? (
          <s
            className="tw:text-sm"
            dangerouslySetInnerHTML={{
              __html: product.originalPrice,
            }}
          />
        ) : null}

        {onRemove ? (
          <button
            onClick={onRemove}
            className="tw:mt-2 tw:text-sm tw:font-medium tw:cursor-pointer"
          >
            <Trash className="tw:h-4 tw:w-4" />
          </button>
        ) : null}
      </div>
    </div>
  );
}
